export default [{
	path: '/ecctt',
	component: () => import('../../views/ecctt'),
	redirect: '/ecctt/home',
	children: [{
			path: 'home',
			component: () => import('../../views/ecctt/home')
		}, {
			path: 'yu',
			component: () => import('../../views/ecctt/yu/index'),
			redirect: '/ecctt/yu/home',
			children: [{
				path: 'home',
				component: () => import('../../views/ecctt/yu/home')
			}, {
				path: 'details',
				component: () => import('../../views/ecctt/yu/details')
			}]
		},
		{
			path: 'xun',
			component: () => import('../../views/ecctt/yu/index'),
			redirect: '/ecctt/xun/home',
			children: [{
					path: 'home',
					component: () => import('../../views/ecctt/xun/home')
				},
				{
					path: 'modelList',
					component: () => import('../../views/ecctt/xun/modelList')
				},
				{
					path: 'resource',
					component: () => import('../../views/ecctt/xun/resource/index')
				},
				{
					path: 'mindmap',
					component: () => import('../../views/ecctt/xun/mindmap/index')
				},
				{
					path: 'wupin',
					component: () => import('../../views/ecctt/xun/wupin/index')
				},
				{
					path: 'pinggu',
					component: () => import('../../views/ecctt/xun/pinggu/index')
				},
				//反思报告
				{
					path: 'reflectionReport',
					component: () => import('../../views/ecctt/xun/reflectionReport/index')
				},
				//居家上门服务派工单
				{
					path: 'jujiapgd',
					component: () => import('../../views/ecctt/xun/jujiapgd/index')
				},
				//养老机构护理服务机构单
				{
					path: 'jigoujgd',
					component: () => import('../../views/ecctt/xun/jigoujgd/index')
				},
				//持续改进照护方案
				{
					path: 'cxgjzhfa',
					component: () => import('../../views/ecctt/xun/cxgjzhfa/index')
				},
				// 社区通用记录单
				{
					path: 'sqtyjld',
					component: () => import('../../views/ecctt/xun/sqtyjld/index')
				},
				// 健康教育海报
				{
					path: 'jkjyhb',
					component: () => import('../../views/ecctt/xun/jkjyhb/index')
				},
				// 照护计划
				{
					path: 'zhjh',
					component: () => import('../../views/ecctt/xun/zhjh/index')
				},
				//沟通与实际照护
				{
					path: 'gtysjzh',
					component: () => import('../../views/ecctt/xun/gtysjzh/index')
				}
			]
		},
		{
			path: 'sai',
			component: () => import('../../views/ecctt/yu/index'),
			redirect: '/ecctt/sai/home',
			children: [{
				path: 'home',
				component: () => import('../../views/ecctt/sai/home')
			}]
		},
		{
			path: 'zhuanjia',
			component: () => import('../../views/ecctt/yu/index'),
			redirect: '/ecctt/zhuanjia/home',
			children: [{
				path: 'home',
				component: () => import('../../views/ecctt/zhuanjia/home')
			}]
		},
		{
			path: 'zjsj',
			component: () => import('../../views/ecctt/yu/index'),
			redirect: '/ecctt/zjsj/home',
			children: [{
				path: 'home',
				component: () => import('../../views/ecctt/zjsj/home')
			}]
		},
		{
			path: 'pinggu',
			component: () => import('../../views/ecctt/yu/index'),
			redirect: '/ecctt/pinggu/home',
			children: [{
				path: 'home',
				component: () => import('../../views/ecctt/pinggu/home')
			}, {
				path: 'details',
				component: () => import('../../views/ecctt/pinggu/details')
			}]
		},
		{
			path: 'personalCenter',
			component: () => import('../../views/ecctt/yu/index'),
			redirect: '/ecctt/personalCenter/home',
			children: [{
				path: 'home',
				component: () => import('../../views/ecctt/personalCenter/home')
			}]
		}
	]
}]